import { ReactNode } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Flex, FlexColumn } from '../Flex';
import { InnerContentContainerDefault, Page as SharedPage } from '../Page/index';
import PageBackground from '../../images/PageBackground.jpg';
import { Header } from '../../..';

// Below is page layout
const PageWrapper = styled.div`${({ theme }) => `
  width: calc(200% + (${theme.padding[4]} * 2));
  background-color: ${theme.colours.primary[6]};
  background-image: url(${PageBackground});
  padding: calc(${theme.padding[11]} + ${theme.padding[1]}) 0;
  background-size: cover;
`}`;

const PageContainer = styled.div`
  width: ${({ theme }) => theme.loginFormWidth};
  margin: 0 auto;
  box-sizing: border-box;
`;

const TriangleTop = styled(Flex)`${({ theme }) => `
  width: 0; 
  height: 0; 
  border-top: ${theme.loginFormArrow} solid transparent;
  border-bottom: 0 solid transparent;
  border-right: ${theme.loginFormWidth} solid ${theme.colours.primary[8]};
`}`;

const TriangleBottom = styled(Flex)`${({ theme }) => `
  width: 0; 
  height: 0; 
  border-bottom: ${theme.loginFormArrow} solid transparent;
  border-top: 0 solid transparent;
  border-left: ${theme.loginFormWidth} solid ${theme.colours.primary[8]};
`}`;

const FormContainer = styled(Flex)`${({ theme }) => `
  background-color: ${theme.colours.primary[8]};
  flex-direction: column;
  padding: calc(${theme.padding[11]} - ${theme.loginFormArrow}) calc(${theme.padding[11]} - ${theme.padding[5]});
`}`;

// General UI Elements
export const LoginFormGrid = styled(Flex)`${({ theme }) => `
  flex-direction: column;
  display: grid;
  grid-gap: ${theme.padding[7]} 0;
`}`;

export const LoginFormTitle = styled.h3`${({ theme }) => `
  font-family: 'Montserrat';
  font-size: calc(${theme.fontSize[5]} + ${theme.fontSize[7]});
  font-weight: ${theme.fontWeight.bolder};
  line-height: calc(${theme.fontSize[5]} + ${theme.fontSize[9]});
  letter-spacing: 0.2px;
  color: ${theme.colours.primary[1]};
  text-align: left;
  margin: 0;
  white-space: pre-line;
`}`;

export const LoginFormTitleIcon = styled(Flex)`${({ theme }) => `
  width: ${theme.padding[11]};
  height: ${theme.padding[11]};
  border-radius: 50%;
  background-color: ${theme.colours.neutral[10]};
  align-items: center;
  justify-content: center;
`}`;

export const LoginRegisterLine = styled(Flex)`${({ theme }) => `
  gap: ${theme.padding[2]};
`}`;

export const LoginRegisterQuestion = styled.span`${({ theme }) => `
  font-family: 'Open Sans';
  font-size: ${theme.fontSize[2]};
  line-height: ${theme.fontSize[6]};
  letter-spacing: 0px;
  text-align: left;
  color: ${theme.colours.neutral[2]};
`}`;

export const LoginLinkStyled = styled(Link)` ${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-family: 'Open Sans';
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
  line-height: ${theme.fontSize[6]};
  letter-spacing: 0px;
  text-align: right;
`}`;

export const LoginErrorText = styled.p`${({ theme }) => `
  margin-top: ${theme.padding[1]};
  color: ${theme.colours.danger[1]};
  font-size: ${theme.fontSize[1]};
  font-family: 'Open Sans';
  line-height: ${theme.fontSize[3]};
`}`;

export const LoginColumnWrapper = styled(FlexColumn)`${({ theme }) => `
  gap: ${theme.padding[4]};
`}`;

export const SuccessNote = styled.span` ${({ theme }) => `
  color: ${theme.colours.neutral[2]};
  font-family: 'Open Sans';
  line-height: calc(${theme.fontSize[1]} + ${theme.fontSize[3]});

  font-weight: ${theme.fontWeight.normal};
  font-size: ${theme.fontSize[3]};
`}`;

export const InnerContentContainer = styled(InnerContentContainerDefault)`
  padding:0;
`;

export function GeneralLoginPage({
  subHeader,
  children,
}: {
  subHeader?: ReactNode;
  children: ReactNode;
}) {
  return (
    <SharedPage
      header={<Header><></></Header>}
      subHeader={subHeader}
      InnerContentContainer={InnerContentContainer}
    >
      <PageWrapper>
        <PageContainer>
          <TriangleTop />
          <FormContainer>
            <LoginFormGrid>
              {children}
            </LoginFormGrid>
          </FormContainer>
          <TriangleBottom />
        </PageContainer>
      </PageWrapper>
    </SharedPage>
  );
}
